<template>
  <div class="device_alarm">
    <div class="left">
      <ChildComponent
        title="车牌识别"
        :count="data?.securityLaneIdentification"
      ></ChildComponent>
      <ChildComponent
        title="破胎器"
        :count="data?.tireCrushing"
      ></ChildComponent>
      <ChildComponent
        title="汽车衡系统"
        :count="data?.truckScales"
      ></ChildComponent>
    </div>
    <div class="center" id="device_center">
      <div class="number total">
        <span class="artistic_font_numbers">{{ data?.total }}</span>
        次
      </div>
      <div class="gray_text">总报警数</div>
    </div>
    <div class="right">
      <ChildComponent
        title="车载人脸"
        :count="data?.carMountedFacialRecognition"
      ></ChildComponent>
      <ChildComponent
        title="闸机"
        :count="data?.gateEquipment"
      ></ChildComponent>
      <ChildComponent
        title="防撞柱"
        :count="data?.liftingAntiCollisionPillar"
      ></ChildComponent>
    </div>
  </div>
</template>

<script setup>
  import {
    ref,
    onMounted,
    onUnmounted,
    defineExpose,
    defineComponent,
  } from 'vue'
  import { getDeviceAlarmCounts } from '@/api/dashboard'

  // 计算圆形半径
  function resize() {
    const parentElement = document.querySelector('.device')
    const circleElement = document.querySelector('#device_center')

    const parentWidth = parentElement.clientWidth
    const parentHeight = parentElement.clientHeight

    const diameter = Math.min(parentWidth / 3, (parentHeight * 2) / 3)
    circleElement.style.setProperty('--circle-diameter', diameter + 'px')
  }
  onMounted(resize)

  // 请求数据
  const data = ref()
  const timer = ref()
  async function fetch() {
    const res = await getDeviceAlarmCounts()
    if (res.success) {
      data.value = res.data
    }
  }
  onMounted(() => {
    fetch()
    timer.value = setInterval(fetch, 60 * 1000)
  })
  onUnmounted(() => clearInterval(timer.value))

  defineExpose({ resize })

  // 定义子组件
  const ChildComponent = defineComponent({
    props: {
      title: {
        type: String,
        required: true,
      },
      count: {
        type: Number,
        required: true,
      },
    },
    template: `
      <div>
        <div class="gray_text">{{ title }}</div>
        <div>
          <span :class="'artistic_font_numbers ' + (count?'red_number':'green_number')">{{ count }}</span> 个
        </div>
      </div>
    `,
  })
</script>

<style lang="less" scoped>
  .device_alarm {
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-align: center;

    /deep/ .number {
      color: #ffffff;
    }
    /deep/ .gray_text {
      color: #ffffff8c;
      font-size: 13px;
    }
    /deep/ .green_number {
      color: #00d900;
    }
    /deep/ .red_number {
      color: #e53200;
    }
    .center {
      display: flex;
      flex-direction: column;
      --circle-diameter: 0px; /* 占位符，通过JS设置 */
      width: var(--circle-diameter);
      height: var(--circle-diameter);
      border-radius: 50%;
      background: linear-gradient(135deg, #b58407, #dfa616);
      align-items: center;
      justify-content: center;
      .total {
        font-size: 20px;
      }
    }
    .right,
    .left {
      height: 100%;
      flex: 0.45;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
  }
</style>
